import React, { useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { ConfigurationStateContext } from '../../store/configurationState/ConfigurationStateProvider';
import {useProductModelStore} from '../../store/productModelStore'
import { useDocumentsStateStore } from "../../store/documentsStateStore";
import { createAppDataProvider } from "../../services/bimVisualizerApi/appDataProviders/AppDataProviderFactory";
import { useServicesState } from "../../store/servicesStateStore";
import { useUserStateStore } from "../../store/userStateStore";
import { DataProviderContextEnum } from "../../enums/DataProviderContextEnum";
import { useRoomNotesStore } from "../../store/roomNotesStore";

const AppDataProviderSelectorComponent = ({ dataProviderContext }: { dataProviderContext: DataProviderContextEnum }) => {

  const { configurationState } = useContext(ConfigurationStateContext);
  
  const {setValues} = useProductModelStore();
  
  const [isLoading, setIsLoading] = useState(false);

  const [searchParams] = useSearchParams();
  const routeParams = useParams();

  // Path params (e.g. /projects/:projectGlobalId/apartments/:apartmentGlobalId) are merged with query params
  const params = new URLSearchParams(searchParams);
  Object.entries(routeParams).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });

  const dataProvider = createAppDataProvider(params, configurationState, dataProviderContext);
  useServicesState.getState().setDataProvider(dataProvider);

  // Load spatial structure model
  const loadRootProduct = async () => {
    
    if (dataProvider)
    {
      setIsLoading(true);
      const result = await dataProvider?.loadRootProduct();

      if (result)
      {
        setValues(result.products, result.apartments, result.materials);
      }
      
      setIsLoading(false);
    }
  }

  // Load spatial structure model
 const loadDocuments = async () => {
    if (dataProvider) {
      setIsLoading(true);
      const result = await dataProvider.loadDocuments();

      let doc = result.length > 0 
                ? await dataProvider.loadDocument(result[0].document.documentUuid)
                : await dataProvider.createInitialDocument();
      
      useDocumentsStateStore.getState().setDocuments(doc ? [doc] : []);
      
      setIsLoading(false);
    }
  }

  const loadCurrentUser = async () => {
        if (dataProvider) {
            const user = await dataProvider.getCurrentUser();
            if (user) {
                useUserStateStore.getState().setCurrentUserId(user.auth0Id);
            }
        }
    }

  // Room notes come from CoreAPI, not the sfp-api model
  const loadRoomNotes = async () => {
        if (dataProvider) {
            const [rooms, canEdit] = await Promise.all([dataProvider.loadRoomNotes(), dataProvider.canEditRoomNotes()]);
            useRoomNotesStore.getState().setRooms(rooms);
            useUserStateStore.getState().setCanEditRoomNotes(canEdit);
        }
    }

  // Run once after component is mounted
  useEffect( () => {
      if (configurationState.configurationLoaded && !isLoading)
      {
        loadRootProduct();
        loadDocuments();
        loadCurrentUser();
        loadRoomNotes();
      }
      
  }, [configurationState]);

  return <>
  </>
    
}

export default AppDataProviderSelectorComponent;